// src/stores/auth.js

import {defineStore} from 'pinia';
import {
    login as loginService,
    logout as logoutService,
    recovery as recoveryService,
    register as registerService,
    verify as verifyService,
    reset as resetService
} from '@/services/authService';

export const useAuthStore = defineStore('auth', {
    state: () => ({
        token: localStorage.getItem('authToken') || null,
        user: JSON.parse(localStorage.getItem('user')) || null, // Parse user info if available
    }),
    getters: {
        isAuthenticated: (state) => !!state.token,
        getUser: (state) => state.user, // Get user details easily
    },
    actions: {
        async login(email, password) {
            try {
                const response = await loginService(email, password); // Assuming this returns user details with the token
                const { token, ...user } = response;

                this.token = token;
                this.user = user;

                // Securely store token and user data
                localStorage.setItem('authToken', token);
                localStorage.setItem('user', JSON.stringify(user));

                //window.location.reload(); // Recarga la página al cerrar sesión
            } catch (error) {
                console.error('Error during login:', error);
                throw error; // Rethrow to handle in the component
            }
        },
        async recovery(email) {
            try {
                return await recoveryService(email);
            } catch (error) {
                console.error('Error during recovery account:', error);
                throw error; // Rethrow to handle in the component
            }
        },
        async verify(email,code){
            try {
                return await verifyService(email,code);
            } catch (error) {
                console.error('Error during verify account:', error);
                throw error; // Rethrow to handle in the component
            }
        },
        async reset(email,code,password){
            try {
                return await resetService(email,code,password);
            } catch (error) {
                console.error('Error during reset password:', error);
                throw error; // Rethrow to handle in the component
            }
        },
        async register(name, email, phone, password) {
            try {
                const response = await registerService(name, email, phone, password); // Assuming this returns user details with the token
                const { token, ...user } = response;

                this.token = token;
                this.user = user;

                // Securely store token and user data
                localStorage.setItem('authToken', token);
                localStorage.setItem('user', JSON.stringify(user));
            } catch (error) {
                console.error('Error during registration:', error);
                throw error; // Rethrow to handle in the component
            }
        },
        async logout() {
            try {
                await logoutService();
                this.token = null;
                this.user = null;

                localStorage.removeItem('authToken');
                localStorage.removeItem('user');
                window.location.reload(); // Recarga la página al cerrar sesión
            } catch (error) {
                console.error('Error during logout:', error);
            }
        },
        async info() {
            return this.user;
        }
    },
});
